import 'core-js/modules/es.object.assign.js';
import { __rest } from '../../../_virtual/_tslib.js';
import { jsxs, jsx } from 'react/jsx-runtime';
import KeyboardDoubleArrowDownOutlined from '@mui/icons-material/KeyboardDoubleArrowDownOutlined';
import KeyboardDoubleArrowUpOutlined from '@mui/icons-material/KeyboardDoubleArrowUpOutlined';
import { styled, css } from '@mui/material/styles';
import { Stack, spacing } from '@mui/system';
import { shouldNotForwardProps, spacing as spacing$1, withUtility } from '../../foundation/utils.js';
import '../assist-chip/assist-chip.js';
import '@mui/material';
import '../button/button.js';
import '../card/card.js';
import '../checkbox/checkbox.js';
import '../container/container.js';
import '../dialog/dialog.js';
import '../divider/divider.js';
import '../donut/donut.js';
import '@mui/icons-material/ArrowBack';
import '@mui/material/Drawer';
import '@mui/icons-material/ContentCopyRounded';
import '../fast-copy/fast-copy.types.js';
import '../feedback-banner/feedback-banner.js';
import '../filter-chip-select/filter-chip-select.js';
import '../filter-chip/filter-chip.js';
import '../line/line.js';
import '../link/link.js';
import '../logo/logo.js';
import '../menu-list/menu-list.js';
import '../modal/modal.js';
import 'core-js/modules/es.parse-int.js';
import 'react';
import '../pagination/pagination.types.js';
import '../popover/popover.js';
import '../radio/radio.js';
import '../../foundation/theme/theme.js';
import '../select/select.js';
import '../snackbar/snackbar.js';
import '../snackbar/snackbar.types.js';
import './stats.types.js';
import '../switch/switch.js';
import '../table/table.js';
import '../table/table.types.js';
import '../tabs/tabs.js';
import '../tag/tag.js';
import '../tag/tag.types.js';
import '../text-field/text-field.js';
import { Text } from '../text/text.js';
import '../tooltip/tooltip.js';

let _ = t => t,
  _t,
  _t2,
  _t3,
  _t4,
  _t5,
  _t6,
  _t7,
  _t8,
  _t9,
  _t10,
  _t11;
const StatsStyled = styled(Stack, {
  shouldForwardProp: shouldNotForwardProps
})(_t || (_t = _`
  ${0};
  width: fit-content;
  height: fit-content;

  ${0}

  ${0};
`), spacing, ({
  size,
  icon
}) => {
  switch (true) {
    case size === 'large':
      return css(_t2 || (_t2 = _`
          padding: ${0} ${0};
          border-radius: ${0};
        `), spacing$1(2), spacing$1(4), spacing$1(4.5));
    case size === 'tiny':
      return css(_t3 || (_t3 = _`
          padding: ${0} ${0};
          border-radius: ${0};
        `), spacing$1(1), spacing$1(2), spacing$1(3.5));
    default:
      return css(_t4 || (_t4 = _`
          padding: ${0} ${0};
          border-radius: ${0};
        `), icon ? spacing$1(1) : spacing$1(2), spacing$1(4), spacing$1(3.5));
  }
}, withUtility(({
  palette
}, {
  variant
}) => {
  switch (true) {
    case variant === 'positive':
      return css(_t5 || (_t5 = _`
          background-color: ${0};
          color: ${0};
        `), palette('surfaceAt4'), palette('success'));
    case variant === 'negative':
      return css(_t6 || (_t6 = _`
          background-color: ${0};
          color: ${0};
        `), palette('errorContainer'), palette('onErrorContainer'));
    case variant === 'neutral':
      return css(_t7 || (_t7 = _`
          background-color: ${0};
          color: ${0};
        `), palette('surfaceVariant'), palette('onSurfaceVariant'));
    case variant === 'neutralVariant':
      return css(_t8 || (_t8 = _`
          background-color: ${0};
          color: ${0};
        `), palette('outline'), palette('surface'));
    case variant === 'attention':
      return css(_t9 || (_t9 = _`
          background-color: ${0};
          color: ${0};
        `), palette('warningContainer'), palette('onWarningContainer'));
    case variant === 'informative':
      return css(_t10 || (_t10 = _`
          background-color: ${0};
          color: ${0};
        `), palette('infoContainer'), palette('onInfoContainer'));
    default:
      return css(_t11 || (_t11 = _``));
  }
}));
const getIcon = icon => {
  switch (icon) {
    case 'up':
      return jsx(KeyboardDoubleArrowUpOutlined, {});
    case 'down':
      return jsx(KeyboardDoubleArrowDownOutlined, {});
    default:
      return null;
  }
};
const Stats = _a => {
  var {
      children,
      variant,
      icon,
      size
    } = _a,
    props = __rest(_a, ["children", "variant", "icon", "size"]);
  return jsxs(StatsStyled, Object.assign({
    direction: "row",
    alignItems: "center",
    size: size,
    variant: variant,
    icon: icon,
    gap: 1
  }, props, {
    children: [icon && jsx(Stack, Object.assign({
      direction: "row",
      marginLeft: -1
    }, {
      children: getIcon(icon)
    })), jsx(Stack, Object.assign({
      direction: "row"
    }, {
      children: jsx(Text, Object.assign({
        variant: size === 'large' ? 'body2' : 'caption'
      }, {
        children: children
      }))
    }))]
  }));
};

export { Stats };
